import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../../../../../components/ui/tooltip'
import { BasicAvatar } from '../../../../../../../components/BasicAvatar'

type TransactionDetailsCardProps = {
  seller: string
  photo: string
  count: number
  isClient: boolean
}

export const TransactionDetailsCard = ({
  seller,
  photo,
  count,
  isClient,
}: TransactionDetailsCardProps) => {
  return (
    <div className="flex flex-col gap-2">
      <BasicAvatar name={seller} profileImageUrl={photo} />
      <p className="text-sm font-semibold">{seller}</p>
      {!isClient && (
        <div className="flex items-center gap-2">
          <p className="text-xs font-medium text-[#747474]">
            {count} saques no último mês
          </p>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <i className="fa-solid fa-circle-info text-black"></i>
              </TooltipTrigger>
              <TooltipContent className="w-52 rounded-xl bg-black">
                <p className="text-xs text-white">
                  O <b>&quot;SAQUE&quot;</b> é a transferência dos seus ganhos
                  de comissão para sua conta bancária. Este processo pode levar
                  até 8 dias para ser aprovado.
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      )}
    </div>
  )
}
